import { Node, mergeAttributes } from '@tiptap/core'

export const AssignCallout = Node.create({
  name: 'assignCallout',

  group: 'inline',

  inline: true,

  addAttributes() {
    return {
      class: {
        default: 'assign-callout',
        parseHTML: element => element.getAttribute('class'),
        renderHTML: attributes => {
          return {
            class: attributes.class || 'assign-callout'
          }
        }
      },
      'data-recipient-email': {
        default: null,
        parseHTML: element => element.getAttribute('data-recipient-email'),
        renderHTML: attributes => {
          if (!attributes['data-recipient-email']) {
            return {}
          }
          return {
            'data-recipient-email': attributes['data-recipient-email']
          }
        }
      },
      'data-recipient-initial': {
        default: null,
        parseHTML: element => element.getAttribute('data-recipient-initial'),
        renderHTML: attributes => {
          if (!attributes['data-recipient-initial']) {
            return {}
          }
          return {
            'data-recipient-initial': attributes['data-recipient-initial']
          }
        }
      },
      'data-recipient-color-index': {
        default: null,
        parseHTML: element => element.getAttribute('data-recipient-color-index'),
        renderHTML: attributes => {
          if (!attributes['data-recipient-color-index']) {
            return {}
          }
          return {
            'data-recipient-color-index': attributes['data-recipient-color-index']
          }
        }
      },
      'data-is-reassign': {
        default: null,
        parseHTML: element => element.getAttribute('data-is-reassign'),
        renderHTML: attributes => {
          if (attributes['data-is-reassign'] !== 'true') {
            return {}
          }
          return {
            'data-is-reassign': 'true'
          }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span.assign-callout',
        getAttrs: (node: string | HTMLElement) => {
          if (typeof node === 'string') return false
          const recipientEmail = node.getAttribute('data-recipient-email')
          const recipientInitial = node.getAttribute('data-recipient-initial')
          const colorIndex = node.getAttribute('data-recipient-color-index')
          const isReassign = node.getAttribute('data-is-reassign')
          return {
            'data-recipient-email': recipientEmail || null,
            'data-recipient-initial': recipientInitial || null,
            'data-recipient-color-index': colorIndex || null,
            'data-is-reassign': isReassign === 'true' ? 'true' : null
          }
        }
      }
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    const recipientEmail = node.attrs['data-recipient-email']
    const recipientInitial = node.attrs['data-recipient-initial']
    const colorIndex = node.attrs['data-recipient-color-index']
    const isReassign = node.attrs['data-is-reassign'] === 'true'
    const displayText = recipientEmail || (isReassign ? 'Reassign recipient' : 'Assign recipient')

    const attrs: Record<string, string> = {
      class: 'assign-callout'
    }
    if (recipientEmail) {
      attrs['data-recipient-email'] = recipientEmail
    }
    if (recipientInitial) {
      attrs['data-recipient-initial'] = recipientInitial
    }
    if (colorIndex) {
      attrs['data-recipient-color-index'] = colorIndex
    }

    // If recipient exists, render with avatar, otherwise render text only
    if (recipientEmail && recipientInitial && colorIndex != null && colorIndex !== '') {
      const avatarClass = `callout-avatar color-index-${colorIndex}`
      return [
        'span',
        mergeAttributes(HTMLAttributes, attrs),
        ['span', { class: avatarClass }, recipientInitial],
        ['span', { class: 'callout-text' }, displayText]
      ]
    }

    return ['span', mergeAttributes(HTMLAttributes, attrs), displayText]
  }
})
